/**
 * @generated SignedSource<<0375201372d728b64391d2251dbbce1b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WorkspaceTodoStatus = "ARCHIVED" | "DRAFT" | "PUBLISHED" | "SCHEDULED";
export type WorkspaceTodoReceiversQuery$variables = {
  workspaceId: string;
  workspaceTodoId: string;
};
export type WorkspaceTodoReceiversQuery$data = {
  readonly todoWorkspace: {
    readonly id: string;
    readonly potentialReceiverStores: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"ReceiverStoresSelector_receiverStores">;
    }>;
    readonly receiverStores: ReadonlyArray<{
      readonly id: string;
    }>;
    readonly status: WorkspaceTodoStatus;
    readonly topic: {
      readonly id: string;
      readonly isPrivate: boolean;
    } | null;
    readonly updatedAtDate: {
      readonly isoString: string;
      readonly " $fragmentSpreads": FragmentRefs<"FormattedDate">;
    } | null;
    readonly updatedBy: {
      readonly id: string;
      readonly name: string;
    } | null;
  };
  readonly workspace: {
    readonly topics: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"TopicSelector_orgTopic">;
    }> | null;
  };
};
export type WorkspaceTodoReceiversQuery = {
  response: WorkspaceTodoReceiversQuery$data;
  variables: WorkspaceTodoReceiversQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workspaceId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workspaceTodoId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "workspaceId"
  }
],
v3 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "workspaceTodoId"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPrivate",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "OrgTopic",
  "kind": "LinkedField",
  "name": "topic",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v6/*: any*/)
  ],
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isoString",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "updatedBy",
  "plural": false,
  "selections": [
    (v9/*: any*/),
    (v4/*: any*/)
  ],
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "Store",
  "kind": "LinkedField",
  "name": "receiverStores",
  "plural": true,
  "selections": [
    (v4/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "WorkspaceTodoReceiversQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "Workspace",
        "kind": "LinkedField",
        "name": "workspace",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "OrgTopic",
            "kind": "LinkedField",
            "name": "topics",
            "plural": true,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "TopicSelector_orgTopic"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": (v3/*: any*/),
          "concreteType": "TodoWorkspace",
          "kind": "LinkedField",
          "name": "todoWorkspace",
          "plural": false,
          "selections": [
            (v4/*: any*/),
            (v5/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "ReceiverStore",
              "kind": "LinkedField",
              "name": "potentialReceiverStores",
              "plural": true,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "ReceiverStoresSelector_receiverStores"
                }
              ],
              "storageKey": null
            },
            (v7/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "UnzonedDate",
              "kind": "LinkedField",
              "name": "updatedAtDate",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "FormattedDate"
                },
                (v8/*: any*/)
              ],
              "storageKey": null
            },
            (v10/*: any*/),
            (v11/*: any*/)
          ],
          "storageKey": null
        },
        "action": "THROW"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "WorkspaceTodoReceiversQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "Workspace",
        "kind": "LinkedField",
        "name": "workspace",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "OrgTopic",
            "kind": "LinkedField",
            "name": "topics",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v9/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "TodoWorkspace",
        "kind": "LinkedField",
        "name": "todoWorkspace",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ReceiverStore",
            "kind": "LinkedField",
            "name": "potentialReceiverStores",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Store",
                "kind": "LinkedField",
                "name": "store",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "includeExternalId",
                        "value": true
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "workspaceBreadcrumbs",
                    "storageKey": "workspaceBreadcrumbs(includeExternalId:true)"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Team",
                "kind": "LinkedField",
                "name": "routedTeams",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "color",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "icon",
                    "storageKey": null
                  },
                  (v6/*: any*/)
                ],
                "storageKey": null
              },
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          (v7/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UnzonedDate",
            "kind": "LinkedField",
            "name": "updatedAtDate",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isDate"
              }
            ],
            "storageKey": null
          },
          (v10/*: any*/),
          (v11/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8e0df4bd6abc066dedc07f1589a6a22d",
    "id": null,
    "metadata": {},
    "name": "WorkspaceTodoReceiversQuery",
    "operationKind": "query",
    "text": "query WorkspaceTodoReceiversQuery(\n  $workspaceTodoId: ID!\n  $workspaceId: ID!\n) {\n  workspace(id: $workspaceId) {\n    topics {\n      ...TopicSelector_orgTopic\n      id\n    }\n    id\n  }\n  todoWorkspace(id: $workspaceTodoId) {\n    id\n    status\n    potentialReceiverStores {\n      ...ReceiverStoresSelector_receiverStores\n      id\n    }\n    topic {\n      id\n      isPrivate\n    }\n    updatedAtDate {\n      ...FormattedDate\n      isoString\n    }\n    updatedBy {\n      name\n      id\n    }\n    receiverStores {\n      id\n    }\n  }\n}\n\nfragment AHTeamIcon on Team {\n  icon\n}\n\nfragment AHTeamIconCircle on Team {\n  color\n  ...AHTeamIcon\n  isPrivate\n}\n\nfragment FormattedDate on Date {\n  __isDate: __typename\n  ...useFormattedDate\n}\n\nfragment OrgStoreWorkspaceBreadcrumbs_store on Store {\n  workspaceBreadcrumbs(includeExternalId: true)\n}\n\nfragment ReceiverStoresSelectorListItem_receiverStore on ReceiverStore {\n  store {\n    ...ReceiverStoresSelectorMain_receiverStore\n    id\n  }\n  routedTeams {\n    ...ReceiverStoresSelectorTeamsIndicator_teams\n    id\n  }\n}\n\nfragment ReceiverStoresSelectorMain_receiverStore on Store {\n  id\n  name\n  ...OrgStoreWorkspaceBreadcrumbs_store\n}\n\nfragment ReceiverStoresSelectorTeamsIndicator_teams on Team {\n  id\n  name\n  ...AHTeamIconCircle\n}\n\nfragment ReceiverStoresSelector_receiverStores on ReceiverStore {\n  store {\n    id\n    name\n    workspaceBreadcrumbs(includeExternalId: true)\n  }\n  ...ReceiverStoresSelectorListItem_receiverStore\n}\n\nfragment TopicSelector_orgTopic on OrgTopic {\n  id\n  name\n  isPrivate\n}\n\nfragment useFormattedDate on Date {\n  __isDate: __typename\n  isoString\n}\n"
  }
};
})();

(node as any).hash = "73653b5d326fa97cb793a5013c3f1814";

export default node;
